import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import SiteInfo from './../models/SiteInfo';

const initialState = {
    isFetching: false,
    isFetched: false,
    siteInfos: [],
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    detail: {
        siteinfo: new SiteInfo()
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SITEINFO_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_LIST_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                siteInfos: action.siteInfos.result,
                pageSize: action.siteInfos.pageSize,
                pageIndex: action.siteInfos.pageIndex,
                totalCount: action.siteInfos.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };
        case Types.SITEINFO_LIST_FAIL:
            return { ...state, isFetching: false, isFetched: true, siteInfos: [] };
        case Types.SITEINFO_DETAIL_ACTION:
            return { ...state, isFetching: true, detail: initialState.detail };
        case Types.SITEINFO_DETAIL_SUCCESS:
            return {
                ...state,
                isFetching: false, isFetched: true,
                detail: {
                    siteinfo: action.siteinfo
                }
            };
        case Types.SITEINFO_DETAIL_FAIL:
            return { ...state, isFetching: false, isFetched: true };
        case Types.SITEINFO_DETAIL_CREATE_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_DETAIL_DELETE_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_DETAIL_UPDATE_ACTION:
            return { ...state, isFetching: true };
        case Types.SITEINFO_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.SITEINFO_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.SITEINFO_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.SITEINFO_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.SITEINFO_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingUpdate: true };
        case Types.SITEINFO_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingUpdate: false };
        case Types.SITEINFO_FAIL:
            return { ...state, isFetching: false, isFetchingUpdate: false, isFetched: true };
        default: 
            return state
    }
}
